<template>
<ProgressCircular v-if="loading" />
  <form v-else novalidate :disabled="disabled" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200px" flat color="transparent">
          <v-card-title>
            <FormHeader
              :loading="loading"
              :link="'page-cultural-organizations'"
              :title="
                getTitle
                  ? `${getTitle} организация культуры`
                  : `Создать организацию культуры`
              "
            />
          </v-card-title>
          <v-card-text>
            <v-container>
              <PageContent height="85">
                <InputTitleSlug
                  :is-loading="loading"
                  :title="fields.organizationName"
                  :title-error="validationErrors.name"
                  :slug="fields.slug"
                  :slug-error="validationErrors.slug"
                  :isSlugEnabled="!isNew"
                  @change:title="fields.organizationName = $event"
                  @change:slug="fields.slug = $event"
                  @input:slug="$v.fields.slug.$touch"
                />
                <v-row>
                  <span>Описание * (<TranslationIcon />)</span>
                  <QuillEditorVue
                  id="description"
                    :cols="12"
                    :title="''"
                    :content="fields.description"
                    :disabled="loading"
                    :isShowErrorMessage="true"
                    :errorText="validationErrors.description"
                    light-mode
                    @input="fields.description = $event"
                    @onChangeContent="$emit('change:descriptionForMobile', { fields, $event })"
                  />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Краткое описание * (<TranslationIcon />)</span>
                    <v-text-field
                      outlined
                      id="shortDescription"
                      :disabled="loading"
                      v-model="fields.shortDescription"
                      :error-messages="validationErrors.shortDescription"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <MediaFilePicker
                      :multiple="false"
                      :file-type="$options.mediaTypesByKeys.IMAGE"
                      :value="fields.imageId"
                      @change="fields.imageId = $event"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" v-if="!!cities">
                    <span>Города</span>
                    <v-select
                      outlined
                      item-value="id"
                      item-text="title"
                      :items="cities"
                      :disabled="loading"
                      :loading="loading"
                      v-model="fields.cityId"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <SeoSettings
                      :data="data"
                      :loading="loading"
                      @on-input-seo="fields = Object.assign({}, fields, $event)"
                    />
                  </v-col>
                </v-row>
              </PageContent>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          v-if="isNew"
          ref="manageSidePanel"
          isShowSortOrder
          :is-new="isNew"
          :is-loading="loading"
          :language="language"
          :entity-id="data.id"
          :entity-type="'culturalOrganization'"
          :translations="fields.translations"
          :sortOrder="fields.sortOrder"
          @cancel="$router.push({ name: 'page-cultural-organizations' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        >
          <template #info-append>
            <StatusPicker
              align="center"
              cols="12"
              title="Статус:"
              :disabled="loading"
              :loading="loading"
              :status="fields.status"
              @status:change="fields.status = $event"
            />
          </template>
        </ManageSidePanel>
        <ManageSidePanel
          v-else-if="data"
          ref="manageSidePanel"
          isShowSortOrder
          :is-new="!data.id"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :language="language"
          :translations="fields.translations"
          :entity-id="data.id"
          :entity-type="'culturalOrganization'"
          :sortOrder="fields.sortOrder"
          @delete="$emit('delete-cultural-organisation')"
          @cancel="$router.push({ name: 'page-cultural-organizations' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        >
          <template #info-append>
            <StatusPicker
              align="center"
              cols="12"
              title="Статус:"
              :disabled="loading"
              :loading="loading"
              :status="fields.status"
              @status:change="fields.status = $event"
            />
            <!-- <v-row align="center">
              <v-col cols="6">
                <span>Посмотреть на сайте</span>
              </v-col>
              <v-col cols="6">
                <v-btn
                  icon
                  link
                  color="primary"
                  target="_blank"
                  :href="redirerectToWebPortal"
                  :loading="loading"
                  ><v-icon>mdi-web</v-icon></v-btn
                >
              </v-col>
            </v-row> -->
            <v-row v-if="!!fields.detailsEntityId" align="center">
              <v-col cols="6">
                <span>Посмотреть общий доступ</span>
              </v-col>
              <v-col cols="6">
                <v-btn
                  icon
                  link
                  color="primary"
                  :to="redirectToSharedAccess"
                  :loading="loading"
                ><v-icon>mdi-account-group</v-icon></v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <DetailComponent
                  :loading="loading"
                  :disabled="disabled"
                  :details-entity-id="fields.detailsEntityId"
                  :details-entity-type="fields.detailsEntityType"
                  @change:details-entity-type="changeDetailsEntityType($event)"
                  @change:details-entity-id="fields.detailsEntityId = $event"
                />
              </v-col>
            </v-row>
          </template>
          <template #body>
            <v-card v-if="getEvents?.length" flat>
              <v-card-subtitle class="grey--text">Связи</v-card-subtitle>
              <v-card-text>
                <v-row>
                  <RelationComponent
                    :events="getEvents"
                    :shared-access="sharedAccess"
                    :ticket-reservations="ticketReservations"
                    :name="getTitle"
                    :loading="loading"
                    :disabled="disabled"
                  />
                </v-row>
              </v-card-text>
            </v-card>
          </template>
        </ManageSidePanel>
      </v-col>
    </v-row>
  </form>
</template>
<script>
import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel'
import validationRules from './validation-rules.js'
import MediaFilePicker from '@/components/media-file-picker'
import SeoSettings from '@/components/seo-settings'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import FormHeader from '@/components/form-header'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
import prepareTranslations from '@/mixins/translations/prepareTranslations.mix'
import QuillEditorVue from '@/components/quill-editor'
import { mixForm } from '@/utils/form.mix.js'
import StatusPicker from '@/components/status-picker'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'
import RelationComponent from '@/components/relation-component'
import DetailComponent from '@/components/detail-component'

export default {
  extends: FormAbstract,
  mixins: [validationTranslations, prepareTranslations, mixForm],
  mediaTypesByKeys: mediaTypesByKeys(),
  name: 'FormCulturalOrganization',
  validationRules,
  props: {
    data: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    },
    cities: {
      type: Array,
      default: null
    },
    sharedAccess: {
      type: Array,
      default: null
    },
    ticketReservations: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: null
    }
  },
  components: {
    PageContent,
    InputTitleSlug,
    TranslationIcon,
    ManageSidePanel,
    MediaFilePicker,
    SeoSettings,
    FormHeader,
    QuillEditorVue,
    StatusPicker,
    ProgressCircular,
    RelationComponent,
    DetailComponent
  },
  data () {
    return {
      fields: {
        organizationName: null,
        slug: undefined,
        description: null,
        shortDescription: null,
        imageId: null,
        cityId: null,
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoDisallowIndex: false,
        seoMetaKeywords: null,
        seoRelCanonical: null,
        seoOgImage: null,
        status: null,
        detailsEntityId: null,
        detailsEntityType: null,
        translations: { ru: { isEnabled: true } },
        sortOrder: null
      }
    }
  },
  computed: {
    getTitle () {
      if (this.data) {
        return this.data?.organizationName || ''
      }
      return null
    },
    validationRulesVars () {
      return { id: this.data?.id, ctx: this, isNew: this.isNew }
    },
    getEvents () {
      return this.data?.events || null
    }
  },
  watch: {
    data (data) {
      this.populate(data)
      this.fields.imageId = data?.image?.id || null
      this.fields.cityId = data?.city?.id || null
    }
  },
  methods: {
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      if (!this.mixIsValidTranslations(this.fields.translations)) {
        this.$errorMsg('Не выбран ни один язык для контента!')
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      if (!this.fields.detailsEntityId) {
        delete payload.detailsEntityId
        delete payload.detailsEntityType
      }
      delete payload.seoOgImage
      this.mixPrepareTranslations(payload)

      this.$emit('submit', payload)
    },
    changeDetailsEntityType (event) {
      this.fields.detailsEntityType = event
      this.fields.detailsEntityId = null
    }
  }
}
</script>
